import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuCaldas from '../components/MenuCaldas';
import Sponsors from '../components/Sponsors';
import TableIndividual from '../components/TableIndividual';
import '../assets/styles/containers/Results.sass';

const ResultsCaldas = () => {
  const [category, setCategory] = useState('');
  const [sponsors, setSponsors] = useState([]);
  const [data, setData] = useState({
    finish: [],
    dnfinish: [],
    ebike: [],
    categories: [],
  });
  const [racers, setRacers] = useState({
    finish: [],
    dnfinish: [],
    ebike: [],
  });
  const showEbikes = category === 'E-BIKE' || category === '';

  useEffect(() =>{
    fetch(`${process.env.REACT_APP_URL}/results/2022/caldas`)
    .then(res => res.json())
    .then(res => {
      const finish = res.results.racers.filter((item) => item.dnf === 'N');
      let dnfinish = res.results.racers.filter((item) => item.dnf === 'S');
      dnfinish = dnfinish.sort((a, b) => a.number - b.number);

      setRacers({
        finish: finish,
        dnfinish: dnfinish,
        ebike: res.results.ebike,
      })
      setData({
        finish: finish,
        dnfinish: dnfinish,
        ebike: res.results.ebike,
        categories: res.results.categories,
      })
      setSponsors(res.sponsors);
    })
  }, []);

  const setCategoryState = (category) => {
    setCategory(category);

    if (category === '') {
      return Promise.resolve(
        setData({
          ...data,
          finish: racers.finish,
          dnfinish: racers.dnfinish,
        })
      );
    }

    return Promise.resolve(
      setData({
        ...data,
        finish: racers.finish.filter((item) => item.category_es === category),
        dnfinish: racers.dnfinish.filter((item) => item.category_es === category),
      })
    );
  };

  const setSearchState = (keyword) => {
    if (keyword) {
      return Promise.resolve(
        setData({
          ...data,
          finish: data.finish.filter(racer => racer.racer.includes(keyword.toUpperCase())),
          dnfinish: data.dnfinish.filter(racer => racer.racer.includes(keyword.toUpperCase())),
          ebike: data.ebike.filter(racer => racer.racer.includes(keyword.toUpperCase())),
        })
      )
    }
    return;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    let target = event.target

    try {
      await setCategoryState(target.categorias.value)
      if(target.search_racer.value) {
        await setSearchState(target.search_racer.value)
      }
    } catch (error) {
      console.log(error)
    }
  };

  return (
    <Layout>
      <Banner id={13} city="caldas" thumb="/caldas/logo_caldas.png" />
      <MenuCaldas />
      <div className="row content-caldas">
        <div className="container">
          <div className="row no-gutters">
            <form onSubmit={handleSubmit} className="results-form">

              <div className="results-form__inputs">
                <div className="results-form__container">
                  <label htmlFor="resultados" className="col-sm-4 ptop">Año</label>
                  <select name="resultados" id="resultados" className="form-control">
                    <option value="2022">2022</option>
                  </select>
                </div>
    
                <div className="results-form__container">
                  <label htmlFor="categorias" className="col-sm-4 ptop">Categoría</label>
                  <select name="categorias" id="categorias" className="form-control">
                    <option value="">TODAS</option>
                    <option value="ABIERTO MASCULINO">ABIERTO MASCULINO</option>
                    <option value="ABIERTO FEMENINO">ABIERTO FEMENINO</option>
                    <option value="MASTER 30+">MASTER 30+</option>
                    <option value="MASTER 40+">MASTER 40+</option>
                    <option value="GRANDMASTER 50+">GRANDMASTER 50+</option>
                    <option value="MASTER FEMENINO 35+">MASTER FEMENINO 35+</option>
                    <option value="E-BIKE">E-BIKE</option>
                  </select>
                </div>
    
                <div className="results-form__container">
                  <label htmlFor="year" className="col-sm-4 control-label-left">Buscar corredores</label>
                  <input className="form-control" type="text" name="search_racer"/>
                </div>
              </div>
              
              <div className="results-form__cta">
                <button className="results-form__btn --caldas" type="submit">VER RESULTADOS</button>
              </div>

            </form>
          </div>

          {data.finish.length > 0 &&
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2022 - SERIES CALDAS - GC - CARRERA {category !== '' && `- ${category}`}</h1>
                </div>
              </div>
              
              <TableIndividual city="caldas" racers={data.finish} />
            </>
          }

          {data.dnfinish.length > 0 &&
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2022 - SERIES CALDAS - GC - CARRERA - NO FINALIZADOR {category !== '' && `- ${category}`}</h1>
                </div>
              </div>
              
              <TableIndividual city="caldas" racers={data.dnfinish} />
            </>
          }

          {data.ebike.length > 0 && showEbikes &&
            <>
              <div className="row">
                <div className="col-12">
                  <h1 className="results-form__title">2022 - SERIES CALDAS - GC - CARRERA E-BIKE</h1>
                </div>
              </div>
              
              <TableIndividual city="caldas" racers={data.ebike} />
            </>
          }

        </div>
      </div>

      {sponsors.length > 0 &&
        <Sponsors
          customClass="--caldas"
          items={sponsors}
        />
      }
    </Layout>
  );
};

export default ResultsCaldas;
